// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '0.0.1';
export const APP_NAME = 'classic-car-investor';
export const FILE_HASH = '1665678313588';
export const BUILD_DATE = '2022-10-13T16:25:13.588Z';
/* tslint:enable */
